import SidebarMenuItem from "features/shared/layout/sidebar/models/SidebarMenuItem";

export enum SidebarActionTypes {    
  SET_SIDEBAR_SHOW = "@@sidebar/SET_SIDEBAR_SHOW",
  SET_SIDEBAR_MENU_ITEMS = "@@sidebar/SET_SIDEBAR_MENU_ITEMS"
}

export type SidebarAction = 
  | { type: SidebarActionTypes.SET_SIDEBAR_SHOW, data: boolean }
  | { type: SidebarActionTypes.SET_SIDEBAR_MENU_ITEMS, data: SidebarMenuItem[] };

export const setSidebarShow = (show: boolean): SidebarAction => ({
  type: SidebarActionTypes.SET_SIDEBAR_SHOW,
  data: show
});

export const setSidebarMenuItems = (items: SidebarMenuItem[]): SidebarAction => ({
  type: SidebarActionTypes.SET_SIDEBAR_MENU_ITEMS,
  data: items
});
